export default __webpack_public_path__ + "static/media/thumbnail.cc279d8c.png";